export default __webpack_public_path__ + "static/media/fleet_speed_icon.f1538051.svg";